/**
 * Auth API Service
 *
 * Sign-up/sign-in handled by Supabase Auth directly (via AuthContext).
 * Only profile endpoint remains here for backend calls.
 */

import { apiClient, BaseAPIService } from './client';

class AuthAPI extends BaseAPIService {
  async getProfile(): Promise<any> {
    const response = await apiClient.get('/api/v1/auth/profile');
    return response.data;
  }
}

export const authApi = new AuthAPI();
